module.exports = __webpack_public_path__ + "static/naturalist-cutout-2ad2fc244d0d13907090aec350701380.png";